@if ((orderTemplatesOptions$ | async).length === 0) {
<formly-form [form]="formGroup()" [fields]="singleFieldConfig" />
} @else {
<div class="col-md-12">
  <formly-form [form]="formGroup()" [fields]="multipleFieldConfig$ | async" />
</div>
} @if (loading$ | async) {
<ish-loading />
}
